import React, { useState, useMemo } from "react";
import { ApolloConsumer } from "@apollo/client";
import ReactTooltip from "react-tooltip";
import momentTimezone from "moment-timezone";
import NoDataComponent from "./../../../../components/Table/TableComponents/NoDataComponent";
// import { CasesContext } from "../../CasesContext";
import "./../../../../components/Cases/cases.scss";
import "./CaseDocumentsTable.scss";
import getDocument from "../../../Utils/DocumentLink";
// import {
//   GET_SUBMITTED_PAGINATED_DATA,
//   GET_HISTORICAL_PAGINATED_DATA,
//   GET_INITIATED_PAGINATED_DATA,
//   GET_PRESUBMITTED_PAGINATED_DATA,
// } from "../../../../screens/Cases/queries";
import { FaSpinner, FaDownload } from "react-icons/fa";
import { ReactTable } from "../../../SimpleForm/ReactTable/index.js";

function CaseDocumentsTable(props) {
  const { searchText, docs, manualPagination } = props;

  let newDocs = [...docs];
  for (let i = 0; i < newDocs.length; i++) {
    for (let item in newDocs[i]) {
      if (
        item === "docCategory" &&
        newDocs?.[i]?.[item] === "Housing Inspection"
      ) {
        newDocs.splice(i, 1);
      }
    }
  }

  // const queryResolver = (type) => {
  //   const resolver = {
  //     Initiated: GET_INITIATED_PAGINATED_DATA,
  //     Presubmitted: GET_PRESUBMITTED_PAGINATED_DATA,
  //     Submitted: GET_SUBMITTED_PAGINATED_DATA,
  //     Historical: GET_HISTORICAL_PAGINATED_DATA,
  //   };
  //   return resolver[type];
  // };
  // const { activeTab, filterBy } = useContext(CasesContext);

  // let query = queryResolver(activeTab.machine_name);

  const columns = useMemo(
    () => [
      {
        Header: "Date Received",
        accessor: "docCreatedDate",
        id: "docCreatedDate",
        fixedWidth: 165,
        Cell: ({ cell: { value }, row: { index } }) => {
          value = Number(value);
          const _date = momentTimezone(value)
            .tz("America/New_York")
            .format("LL");
          return (
            <>
              <span data-tip data-for={`docCreatedDate${index}`}>
                {_date || "--"}
              </span>
              <ReactTooltip
                type="dark"
                effect="solid"
                id={`docCreatedDate${index}`}
              >
                <span>{_date || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      {
        Header: "Document Name",
        accessor: "docName",
        id: "docName",
        sortType: function (a, b) {
          if (!manualPagination) {
            a = a.values.docName ? a.values.docName.toLowerCase() : "";
            b = b.values.docName ? b.values.docName.toLowerCase() : "";
            return a > b ? 1 : -1;
          }
        },
        Cell: ({ cell: { value }, row: { index, original } }) => {
          const dhDocId = original?.dhDocId || "";
          const caseNumber = original?.caseNumber || "";
          const fileName = value;
          let [loading, setLoading] = useState(false);
          const handleGetDocument = async () => {
            setLoading(true);
            await getDocument({
              caseNumber,
              dhDocId,
              fileName,
            });
            setLoading(false);
          };
          return (
            <>
              {/**div over span because on long doc names, tooltip on the right column incorrectly shows  */}
              <div
                data-tip
                data-for={`docName_${index}`}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  marginRight: 20,
                }}
              >
                {fileName || "--"}{" "}
                <div
                  className="case-documents-download-icon"
                  cursor="pointer"
                  onClick={() => {
                    handleGetDocument();
                  }}
                  // Allows keyboard navigation
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handleGetDocument();
                    }
                  }}
                  tabIndex={0}
                >
                  {loading ? (
                    <FaSpinner className="icon-spin" />
                  ) : (
                    <FaDownload />
                  )}
                </div>
              </div>
              <ReactTooltip type="dark" effect="solid" id={`docName_${index}`}>
                <span>{fileName || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      {
        Header: "Document Category",
        accessor: "docCategory",
        id: "docCategory",
        Cell: ({ cell: { value }, row: { index } }) => {
          return (
            <>
              <span data-tip data-for={`docCategory${index}`}>
                {value || "--"}
              </span>
              <ReactTooltip
                type="dark"
                effect="solid"
                id={`docCategory${index}`}
              >
                <span>{value || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      {
        Header: "Submitted By",
        accessor: "submittedBy",
        id: "submittedBy",
        fixedWidth: 150,
        Cell: ({ cell: { value }, row: { index } }) => {
          return (
            <>
              <span data-tip data-for={`submittedBy_${index}`}>
                {value || "--"}
              </span>
              <ReactTooltip
                type="dark"
                effect="solid"
                id={`submittedBy_${index}`}
              >
                <span>{value || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
    ],
    []
  );

  const NoDataConst = (props) => (
    <NoDataComponent noDataResult="There is no data for " {...props} />
  );

  return (
    <ReactTable
      tableTheme="casesTableTheme"
      columns={columns}
      data={newDocs}
      NoDataComponent={NoDataConst}
      pageSizeOptions={[10, 25, 50, 100]}
      defaultSortBy={[
        {
          id: "docCreatedDate",
          desc: false,
        },
      ]}
    />
  );
}

export default (props) => (
  <ApolloConsumer>
    {(client) => (
      <CaseDocumentsTable
        style={{ width: "100%" }}
        apolloClient={client}
        {...props}
      />
    )}
  </ApolloConsumer>
);
